import { Button, Icon } from '@ds/core';
import { dataSimples, moeda } from '@/comuns/formato';
import type { InadimplenciaDaClinica } from '@/data/tipos';

/**
 * O que a clínica lê quando tem fatura vencida (trilha T9).
 *
 * Desde o primeiro dia: a data do vencimento e o dia do bloqueio. Passados 15 dias,
 * o motivo do só leitura e onde pagar. Quem bloqueia é o banco (0117), não esta
 * faixa: ela só conta o que já vale.
 */
export function textoDaInadimplencia(i: InadimplenciaDaClinica): { titulo: string; texto: string } {
    const qual = i.fatura ? ` de ${i.fatura.competencia} (${moeda(i.fatura.valorCentavos)})` : '';
    if (i.bloqueadaEm) {
        return {
            titulo: 'Clínica em modo só leitura',
            texto: `A fatura${qual} venceu em ${dataSimples(i.inadimplenteDesde)} e está em aberto há mais de 15 dias. `
                + 'Você continua vendo tudo, mas não cria nem edita nada até o pagamento. '
                + 'Pague em Configurações › Assinatura: a clínica volta a editar assim que o pagamento é confirmado.',
        };
    }
    return {
        titulo: 'Fatura vencida',
        texto: `Fatura${qual} vencida em ${dataSimples(i.inadimplenteDesde)} — pague para evitar o bloqueio em `
            + `${dataSimples(i.bloqueioPrevistoEm)}. A partir desse dia, a clínica fica só leitura até o pagamento.`,
    };
}

export function AvisoDeInadimplencia({ inadimplencia, onPagar }: {
    inadimplencia: InadimplenciaDaClinica;
    onPagar?: () => void;
}) {
    const { titulo, texto } = textoDaInadimplencia(inadimplencia);
    const bloqueada = Boolean(inadimplencia.bloqueadaEm);
    return (
        <div
            role={bloqueada ? 'alert' : 'status'}
            style={{
                display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
                padding: '9px 18px',
                background: bloqueada ? 'var(--danger-50, #FDECEC)' : 'var(--warning-50, #FDF6E3)',
                borderBottom: '1px solid var(--border)', fontFamily: 'var(--font-ui)', fontSize: 13,
                color: 'var(--text-primary)',
            }}
        >
            <Icon name={bloqueada ? 'lock' : 'triangle-alert'} size={15} />
            <span style={{ flex: '1 1 220px', minWidth: 0 }}>
                <strong>{titulo}.</strong> {texto}
            </span>
            {onPagar && (
                <Button size="sm" variant="secondary" onClick={onPagar}>Ver como pagar</Button>
            )}
        </div>
    );
}
